import { useQuery } from "@tanstack/react-query";
import { apiGet, ApiError } from "../api/client";

export interface Membership {
  workspaceId: string;
  workspaceName: string;
  cxoRoleTag: string;
  // Workspace-level default XI domain (one of the 6 canonical slugs, or null
  // for the "all my domains" view). Drives Inbox/Plays scope and is changed
  // via the topbar DomainSwitcher.
  defaultDomain: string | null;
  role: string;
  // The user's per-workspace domain assignments. A null entry means the user
  // has unrestricted access to all domains in this workspace; non-null
  // entries are explicit domain memberships from XTS company_access.
  domains: (string | null)[];
  acceptedAt: string | null;
}

export interface Me {
  user: { id: string; email: string; displayName: string };
  memberships: Membership[];
}

export function useMe() {
  return useQuery<Me, Error>({
    queryKey: ["me"],
    queryFn: () => apiGet<Me>("/api/me"),
    staleTime: 5 * 60_000,
    retry: (failureCount, err) => {
      if (err instanceof ApiError && err.status === 401) return false;
      return failureCount < 1;
    },
  });
}
